import { pdsUtils } from './pds-utils';
import { AsyncSubject } from 'rxjs';
import { PdsDateWidget } from './pds-date-widget';
import { PdsDateWidgetDialog } from './pds-date-widget-dialog';
import { PdsAppNav } from './pds-app-nav';
import { PdsClassBlock } from './pds-class-block';
import { PdsClassPicker } from './pds-class-picker';
import { PdsDynamicSelect } from './pds-dynamic-select';
import { PdsSelectWidget } from './pds-select-widget';
import { PdsTextWidget } from './pds-text-widget';
import { PdsFilePickerWidget } from './pds-file-picker-widget';
import { PdsNumberWidget } from './pds-number-widget';
import { PdsNumberedSlider } from './pds-numbered-slider';
import { PdsProgressBarWidget } from './pds-progress-bar-widget';
import { PdsReportingTermSelector } from './pds-reporting-term-selector';
import { PdsSearch } from './pds-search';
import { PdsIcon } from './pds-icon';
import { PdsHelpMenu } from './pds-help-menu';
import { PdsGlobalCreateMenu } from './pds-global-create-menu';
import { PdsLoader } from './pds-loader';
import { PdsCircularProgress } from './pds-circular-progress';
import { PdsRadioButtonWidget } from './pds-radio-button-widget';
import { PdsRichTextEditor } from './pds-rich-text-editor';
import { PdsImg } from './pds-img';
import { PdsOverlayDropdown } from './pds-overlay-dropdown';
import { PdsAnnounce } from './pds-announce';
import { PdsNotificationIndicator } from './pds-notification-indicator';
import { PdsActivityFeedNotification } from './pds-activity-feed-notification';
import { PdsRichTextDisplay } from './pds-rich-text-display';
import { PdsDialog } from './pds-dialog';
import { PdsTimeWidget } from './pds-time-widget';
import { PdsCommunicationNotification } from './pds-communication-notification';
import { PdsAssignmentTemplateNotification } from './pds-assignment-template-notification';
import { PdsAssignmentSubmissionNotification } from './pds-assignment-submission-notification';
import { PdsAssignmentReturnNotification } from './pds-assignment-return-notification';
import { PdsChatQuickMessage } from './pds-chat-quick-message';
import { PdsNotificationBadge } from './pds-notification-badge';
import { PdsUserAvatar } from './pds-user-avatar';
import { PdsTooltip } from './pds-tooltip';
import { PdsErrorPage } from './pds-error-page';
import { PdsCopyrightClause } from './pds-copyright-clause';
import { PdsAppSwitcher} from './pds-app-switcher';
import { PdsTextareaWidget } from './pds-textarea-widget';
import { PdsCheckboxWidget } from './pds-checkbox-widget';
import { PdsUserMenu } from './pds-user-menu';
import { PdsImmersiveReader } from './pds-immersive-reader';
import { PdsLogout } from './pds-logout';
import { PdsParsedHtmlContent } from './pds-parsed-html-content';
import { PdsBanner } from './pds-banner';
import { PdsElementRenderer } from './pds-element-renderer';
import { PdsGwDateFilter } from './components/grid-widget/pds-gw-date-filter';
import { PdsGridWidgetFilter } from './components/grid-widget/pds-grid-widget-filter';
import { PdsGridWidgetPaginationControl } from './components/grid-widget/pds-grid-widget-pagination-control';
import { PdsGwMultiFieldFilter } from './components/grid-widget/pds-gw-multi-field-filter';
import { PdsGwMultiSelectFilter } from './components/grid-widget/pds-gw-multi-select-filter';
import { PdsGwNumberFilter } from './components/grid-widget/pds-gw-number-filter';
import { PdsGwPillSelectFilter } from './components/grid-widget/pds-gw-pill-select-filter';
import { PdsGwSelectFilter } from './components/grid-widget/pds-gw-select-filter';
import { PdsGridWidgetSortFields } from './components/grid-widget/pds-grid-widget-sort-fields';
import { PdsGwTextFilter } from './components/grid-widget/pds-gw-text-filter';
import { PdsMultiSelectWidget } from './pds-multi-select-widget';
import { PdsPopOver } from './pds-pop-over';
import { PdsMessagesWidget } from './pds-messages-widget';
import { PdsFormatTime } from './pds-format-time';
import {PdsWizardSteps} from './pds-wizard-steps';
import { PdsFormatNumber } from './pds-format-number';

/*
 This function creates a flattened class instance of the provided token and then strips off parts we don't want
 when using the object as a polymer definition. See createFlattenedClassInstance comment for more details.
 */
export function createFlattenedPolymerDefinition(token: any): any {
  let definition = pdsUtils.createFlattenedClassInstance(token);
  delete (<{ querySelector: any }>definition).querySelector;
  delete (<{ querySelectorAll: any }>definition).querySelectorAll;
  delete (<{ dispatchEvent: any }>definition).dispatchEvent;
  delete (<{ hasAttribute: any }>definition).hasAttribute;
  delete (<{ setAttribute: any }>definition).setAttribute;
  delete (<{ appendChild: any }>definition).appendChild;
  return definition;
}

let pdsWidgetDefinitions = {
  pdsCheckboxWidgetDefinition: createFlattenedPolymerDefinition(PdsCheckboxWidget),
  pdsTextWidgetDefinition: createFlattenedPolymerDefinition(PdsTextWidget),
  pdsTextareaWidgetDefinition: createFlattenedPolymerDefinition(PdsTextareaWidget),
  pdsFilePickerWidgetDefinition: createFlattenedPolymerDefinition(PdsFilePickerWidget),
  pdsSelectWidgetDefinition: createFlattenedPolymerDefinition(PdsSelectWidget),
  pdsNumberWidgetDefinition: createFlattenedPolymerDefinition(PdsNumberWidget),
  pdsDateWidgetDefinition: createFlattenedPolymerDefinition(PdsDateWidget),
  pdsTimeWidgetDefinition: createFlattenedPolymerDefinition(PdsTimeWidget),
  pdsDateWidgetDialogDefinition: createFlattenedPolymerDefinition(PdsDateWidgetDialog),
  pdsDynamicSelectDefinition: createFlattenedPolymerDefinition(PdsDynamicSelect),
  pdsNumberedSliderDefinition: createFlattenedPolymerDefinition(PdsNumberedSlider),
  pdsIconDefinition: createFlattenedPolymerDefinition(PdsIcon),
  pdsAppNav: createFlattenedPolymerDefinition(PdsAppNav),
  pdsHelpMenuDefinition: createFlattenedPolymerDefinition(PdsHelpMenu),
  pdsGlobalCreateMenuDefinition: createFlattenedPolymerDefinition(PdsGlobalCreateMenu),
  pdsClassBlock: createFlattenedPolymerDefinition(PdsClassBlock),
  pdsClassPicker: createFlattenedPolymerDefinition(PdsClassPicker),
  pdsReportingTermSelector: createFlattenedPolymerDefinition(PdsReportingTermSelector),
  pdsSearch: createFlattenedPolymerDefinition(PdsSearch),
  pdsRadioButtonWidgetDefinition: createFlattenedPolymerDefinition(PdsRadioButtonWidget),
  pdsRichTextEditor: createFlattenedPolymerDefinition(PdsRichTextEditor),
  pdsProgressBarWidgetDefinition: createFlattenedPolymerDefinition(PdsProgressBarWidget),
  pdsImgWidgetDefinition: createFlattenedPolymerDefinition(PdsImg),
  pdsLoaderDefinition: createFlattenedPolymerDefinition(PdsLoader),
  pdsCircularProgressDefinition: createFlattenedPolymerDefinition(PdsCircularProgress),
  pdsNotificationIndicator: createFlattenedPolymerDefinition(PdsNotificationIndicator),
  pdsOverlayDropdownDefinition: createFlattenedPolymerDefinition(PdsOverlayDropdown),
  pdsAnnounceDefinition: createFlattenedPolymerDefinition(PdsAnnounce),
  pdsRichTextDisplayDefinition: createFlattenedPolymerDefinition(PdsRichTextDisplay),
  pdsActivityFeedNotification: createFlattenedPolymerDefinition(PdsActivityFeedNotification),
  pdsDialogDefinition: createFlattenedPolymerDefinition(PdsDialog),
  pdsCommunicationNotification: createFlattenedPolymerDefinition(PdsCommunicationNotification),
  pdsAssignmentTemplateNotification: createFlattenedPolymerDefinition(PdsAssignmentTemplateNotification),
  pdsAssignmentSubmissionNotification: createFlattenedPolymerDefinition(PdsAssignmentSubmissionNotification),
  pdsAssignmentReturnNotification: createFlattenedPolymerDefinition(PdsAssignmentReturnNotification),
  pdsChatQuickMessage: createFlattenedPolymerDefinition(PdsChatQuickMessage),
  pdsNotificationBadge: createFlattenedPolymerDefinition(PdsNotificationBadge),
  pdsUserAvatar: createFlattenedPolymerDefinition(PdsUserAvatar),
  pdsTooltip: createFlattenedPolymerDefinition(PdsTooltip),
  pdsErrorPage: createFlattenedPolymerDefinition(PdsErrorPage),
  pdsCopyrightClause: createFlattenedPolymerDefinition(PdsCopyrightClause),
  pdsAppSwitcher: createFlattenedPolymerDefinition(PdsAppSwitcher),
  pdsUserMenuDefinition: createFlattenedPolymerDefinition(PdsUserMenu),
  pdsImmersiveReader: createFlattenedPolymerDefinition(PdsImmersiveReader),
  pdsLogout: createFlattenedPolymerDefinition(PdsLogout),
  pdsParsedHtmlContent: createFlattenedPolymerDefinition(PdsParsedHtmlContent),
  pdsElementRenderer: createFlattenedPolymerDefinition(PdsElementRenderer),
  pdsBanner: createFlattenedPolymerDefinition(PdsBanner),
  pdsDateFilter: createFlattenedPolymerDefinition(PdsGwDateFilter),
  pdsGridWidgetFilter: createFlattenedPolymerDefinition(PdsGridWidgetFilter),
  pdsGridWidgetPaginationControl: createFlattenedPolymerDefinition(PdsGridWidgetPaginationControl),
  pdsMultiFieldFilter: createFlattenedPolymerDefinition(PdsGwMultiFieldFilter),
  pdsMultiSelectFilter: createFlattenedPolymerDefinition(PdsGwMultiSelectFilter),
  pdsNumberFilter: createFlattenedPolymerDefinition(PdsGwNumberFilter),
  pdsPillSelectFilter: createFlattenedPolymerDefinition(PdsGwPillSelectFilter),
  pdsSelectFilter: createFlattenedPolymerDefinition(PdsGwSelectFilter),
  pdsGridWidgetSortFields: createFlattenedPolymerDefinition(PdsGridWidgetSortFields),
  pdsTextFilter: createFlattenedPolymerDefinition(PdsGwTextFilter),
  pdsMultiSelectWidget: createFlattenedPolymerDefinition(PdsMultiSelectWidget),
  pdsPopOver: createFlattenedPolymerDefinition(PdsPopOver),
  pdsFormatTime: createFlattenedPolymerDefinition(PdsFormatTime),
  pdsFormatNumber: createFlattenedPolymerDefinition(PdsFormatNumber),
  pdsWizardSteps: createFlattenedPolymerDefinition(PdsWizardSteps),
  pdsMessagesWidgetDefinition: createFlattenedPolymerDefinition(PdsMessagesWidget)
};

export let polymerUtils = {
  regComplete: new AsyncSubject,
  registeredPolymerComponents: 0,
  pdsWidgetDefinitionCount: Object.keys(pdsWidgetDefinitions).length,
  registerPolymerComponent(definition: string): void {
    if (!pdsWidgetDefinitions.hasOwnProperty(definition)) {
      console.error('"' + definition + '" was not found in list pdsWidgetDefinitions. polymer-utils.ts');
      return;
    }

    (<any>window).Polymer(pdsWidgetDefinitions[definition]);

    this.registeredPolymerComponents++;
    if (this.pdsWidgetDefinitionCount === this.registeredPolymerComponents) {
      this.regComplete.next();
      this.regComplete.complete();
    }
  },
  addPdsObjToPolymerComponent(pds: any): void {
    for (let prop in pdsWidgetDefinitions) {
      if (prop !== 'pdsWidgetDefinitions') {
        pdsWidgetDefinitions[prop].pds = pds;
      }
    }
  },
  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Yuck! Why all these dinky functions?  How come we can't just call registerPolymerComponent in the template?
   * Well, you could, and it would work, but this way is nicer because it allows us to see exactly how long each
   * component takes to register in the Chrome profiler.  This is actually really important because as css grows,
   * the widgets will take longer to initialize. We need to see which ones take a long time so we can refactor css and
   * ensure that only the required css gets injected into these components.
   */
  registerPdsCheckboxWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsCheckboxWidgetDefinition');
  },
  registerPdsSelectWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsSelectWidgetDefinition');
  },
  registerPdsTextWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsTextWidgetDefinition');
  },
  registerPdsTextareaWidgetDefinition: function(): void {
    this.registerPolymerComponent('pdsTextareaWidgetDefinition');
  },
  registerPdsFilePickerWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsFilePickerWidgetDefinition');
  },
  registerPdsNumberWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsNumberWidgetDefinition');
  },
  registerPdsDateWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsDateWidgetDefinition');
  },
  registerPdsTimeWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsTimeWidgetDefinition');
  },
  registerPdsDateWidgetDialogDefinition: function (): void {
    this.registerPolymerComponent('pdsDateWidgetDialogDefinition');
  },
  registerPdsDynamicSelectDefinition: function (): void {
    this.registerPolymerComponent('pdsDynamicSelectDefinition');
  },
  registerPdsNumberedSliderDefinition: function (): void {
    this.registerPolymerComponent('pdsNumberedSliderDefinition');
  },
  registerPdsIconDefinition: function (): void {
    this.registerPolymerComponent('pdsIconDefinition');
  },
  registerPdsAppNav: function (): void {
    this.registerPolymerComponent('pdsAppNav');
  },
  registerPdsHelpMenuDefinition: function (): void {
    this.registerPolymerComponent('pdsHelpMenuDefinition');
  },
  registerPdsGlobalCreateMenuDefinition: function (): void {
    this.registerPolymerComponent('pdsGlobalCreateMenuDefinition');
  },
  registerPdsClassBlock: function (): void {
    this.registerPolymerComponent('pdsClassBlock');
  },
  registerPdsClassPicker: function (): void {
    this.registerPolymerComponent('pdsClassPicker');
  },
  registerPdsReportingTermSelector: function (): void {
    this.registerPolymerComponent('pdsReportingTermSelector');
  },
  registerPdsSearch: function (): void {
    this.registerPolymerComponent('pdsSearch');
  },
  registerPdsRadioButtonWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsRadioButtonWidgetDefinition');
  },
  registerPdsRichTextEditor: function (): void {
    this.registerPolymerComponent('pdsRichTextEditor');
  },
  registerPdsProgressBarWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsProgressBarWidgetDefinition');
  },
  registerPdsImgWidgetDefinition: function (): void {
    this.registerPolymerComponent('pdsImgWidgetDefinition');
  },
  registerPdsLoaderDefinition: function (): void {
    this.registerPolymerComponent('pdsLoaderDefinition');
  },
  registerPdsCircularProgressDefinition: function (): void {
    this.registerPolymerComponent('pdsCircularProgressDefinition');
  },
  registerPdsNotificationIndicator: function (): void {
    this.registerPolymerComponent('pdsNotificationIndicator');
  },
  registerPdsOverlayDropdownDefinition: function (): void {
    this.registerPolymerComponent('pdsOverlayDropdownDefinition');
  },
  registerPdsAnnounceDefinition: function (): void {
    this.registerPolymerComponent('pdsAnnounceDefinition');
  },
  registerPdsRichTextDisplayDefinition: function (): void {
    this.registerPolymerComponent('pdsRichTextDisplayDefinition');
  },
  registerPdsActivityFeedNotification: function (): void {
    this.registerPolymerComponent('pdsActivityFeedNotification');
  },
  registerPdsDialogDefinition: function (): void {
    this.registerPolymerComponent('pdsDialogDefinition');
  },
  registerPdsCommunicationNotification: function (): void {
    this.registerPolymerComponent('pdsCommunicationNotification');
  },
  registerPdsAssignmentTemplateNotification: function (): void {
    this.registerPolymerComponent('pdsAssignmentTemplateNotification');
  },
  registerPdsAssignmentSubmissionNotification: function (): void {
    this.registerPolymerComponent('pdsAssignmentSubmissionNotification');
  },
  registerPdsAssignmentReturnNotification: function (): void {
    this.registerPolymerComponent('pdsAssignmentReturnNotification');
  },
  registerPdsChatQuickMessage: function (): void {
    this.registerPolymerComponent('pdsChatQuickMessage');
  },
  registerPdsNotificationBadge: function (): void {
    this.registerPolymerComponent('pdsNotificationBadge');
  },
  registerPdsUserAvatar: function(): void {
    this.registerPolymerComponent('pdsUserAvatar');
  },
  registerPdsTooltipDefinition: function(): void {
    this.registerPolymerComponent('pdsTooltip');
  },
  registerPdsErrorPage: function(): void {
    this.registerPolymerComponent('pdsErrorPage');
  },
  registerPdsCopyrightClause: function(): void {
    this.registerPolymerComponent('pdsCopyrightClause');
  },
  registerPdsAppSwitcher: function(): void {
    this.registerPolymerComponent('pdsAppSwitcher');
  },
  registerPdsUserMenuDefinition: function(): void {
    this.registerPolymerComponent('pdsUserMenuDefinition');
  },
  registerPdsImmersiveReaderDefinition: function(): void {
    this.registerPolymerComponent('pdsImmersiveReader');
  },
  registerPdsLogoutDefinition: function(): void {
    this.registerPolymerComponent('pdsLogout');
  },
  registerPdsParsedHtmlContentDefinition: function(): void {
    this.registerPolymerComponent('pdsParsedHtmlContent');
  },
  registerPdsElementRendererDefinition: function(): void {
    this.registerPolymerComponent('pdsElementRenderer');
  },
  registerPdsBanner: function(): void {
    this.registerPolymerComponent('pdsBanner');
  },
  registerPdsDateFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsDateFilter');
  },
  registerPdsGridWidgetFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsGridWidgetFilter');
  },
  registerPdsGridWidgetPaginationControlDefinition: function(): void {
    this.registerPolymerComponent('pdsGridWidgetPaginationControl');
  },
  registerPdsMultiFieldFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsMultiFieldFilter');
  },
  registerPdsMultiSelectFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsMultiSelectFilter');
  },
  registerPdsNumberFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsNumberFilter');
  },
  registerPdsPillSelectFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsPillSelectFilter');
  },
  registerPdsSelectFilterDefinition: function(): void {
    this.registerPolymerComponent('pdsSelectFilter');
  },
  registerPdsGridWidgetSortFieldsDefinition: function(): void {
    this.registerPolymerComponent('pdsGridWidgetSortFields');
  },
  registerPdsTextFieldsDefinition: function(): void {
    this.registerPolymerComponent('pdsTextFilter');
  },
  registerPdsMultiSelectWidgetDefinition: function(): void {
    this.registerPolymerComponent('pdsMultiSelectWidget');
  },
  registerPdsPopOverDefinition: function(): void {
    this.registerPolymerComponent('pdsPopOver');
  },
  registerPdsMessagesWidgetDefinition: function(): void {
    this.registerPolymerComponent('pdsMessagesWidgetDefinition');
  },
  registerPdsFormatTimeDefinition: function(): void {
    this.registerPolymerComponent('pdsFormatTime');
  },
  registerPdsWizardStepsDefinition: function(): void {
  this.registerPolymerComponent('pdsWizardSteps');
  },
  registerPdsFormatNumberDefinition: function(): void {
    this.registerPolymerComponent('pdsFormatNumber');
  }
};
